export const packageList = [
  {
    name: 'crm_common',
    activeRule: ['crm-common']
  },
  {
    name: 'crm_pmsys',
    activeRule: ['crm-pmsys']
  },
  {
    name: 'crm_area',
    activeRule: ['crm-area'],
  },
  {
    name: 'crm_wechat',
    activeRule: ['crm-wechat'],
  },
  {
    name: 'crm_marketing',
    activeRule: ['marketing'],
  },
  {
    name: 'crm_price_remote',
    activeRule: ['crm-price-remote'],
  },
  {
    name: 'crm_express',
    activeRule: ['crm-express'],
  },
  {
    name: 'crm_price',
    activeRule: ['crm-price'],
  },
  {
    name: 'crm_intl',
    activeRule: ['crm-intl'],
  },
  {
    name: 'crm_jifen',
    activeRule: ['crm-jifen'],
  },
  {
    name: 'crm_snap',
    activeRule: ['crm-snap'],
  },
  {
    name: 'crm_sales',
    activeRule: ['crm-sales'],
  },
  {
    name: 'crm_exhibition',
    activeRule: ['crm-exhibition'],
  },
  {
    name: 'crm_receiver',
    activeRule: ['crm-receiver'],
  },
  {
    name: 'crm_risk_control',
    activeRule: ['crm-risk'],
  },
  {
    name: 'crm_resource',
    activeRule: ['crm-resource'],
  },
  {
    name: 'crm_offer_report',
    activeRule: ['offerReport', 'crm-offer-report'],
  },
  {
    name: 'crm_kts_remote',
    activeRule: [], // crm 工单远程包没有路由页面，只有远程组件
  },
  {
    name: 'crm_other_report',
    activeRule: ['crm-other-report'],
  },
  {
    name: 'crm_market_info',
    activeRule: ['crm-market-info'],
  },
  {
    name: 'crm_finance_info',
    activeRule: ['crm-finance-info'],
  },
  {
    name: 'crm_customer_follow',
    activeRule: ['crm-customer-follow'],
  },
  {
    name: 'crm_was_report',
    activeRule: ['crm-was-report'],
  },
  {
    name: 'crm_answer',
    activeRule: ['crm-answer'],
  },
  {
    name: 'crm_was',
    activeRule: ['crm-was'],
  },
  {
    name: 'crm_was_config',
    activeRule: ['crm-was-config'],
  },
  {
    name: 'crm_salary',
    activeRule: ['crm-salary'],
  },
  {
    name: 'crm_flow_remote',
    activeRule: [],
  },
  {
    name: 'crm',
    activeRule: ['crm'], // offerReport > crm-offer-report 用layout编码代替路由
  },
  {
    name: 'crm_visit_sign_erp',
    activeRule: ['crm-visit-sign'],
  },
  {
    name: 'crm_take_send_configuration',
    activeRule: ['crm-take-send-configuration'],
  },
  {
    name: 'crm_eam',
    activeRule: ['crm-eam'],
  },
  {
    name: 'crm_deposit',
    activeRule: ['crm-deposit'],
  },
  {
    name: 'crm_market_report',
    activeRule: ['crm-market-report'],
  },
  {
    name: 'crm_resource_report',
    activeRule: ['crm-resource-report']
  },
  {
    name: 'crm_marketing_ai',
    activeRule: ['crm-marketing-ai']
  },
  {
    name: 'crm_common_doc',
    activeRule: ['crm-common-doc'],
  }
]

export const remoteModuleConfig = {
  dev: ['crm', 'crm_kts_remote', 'crm_marketing', 'crm_area', 'crm_wechat', 'crm_price_remote', 'crm_intl', 'crm_offer_report', 'crm_price', 'crm_express', 'crm_risk_control', 'crm_jifen', 'crm_snap', 'crm_sales', 'crm_exhibition', 'crm_receiver', 'crm_common', 'crm_resource', 'crm_other_report', 'crm_market_info', 'crm_finance_info', 'crm_customer_follow', 'crm_was_report', 'crm_answer', 'crm_was', 'crm_was_config', 'crm_salary', 'crm_flow_remote', 'crm_visit_sign_erp', 'crm_take_send_configuration', 'crm_eam', 'crm_pmsys', 'crm_deposit', 'crm_market_report', 'crm_resource_report', 'crm_marketing_ai', 'crm_common_doc'],
  stg: ['crm', 'crm_kts_remote', 'crm_marketing', 'crm_area', 'crm_wechat', 'crm_price_remote', 'crm_intl', 'crm_offer_report', 'crm_price', 'crm_express', 'crm_risk_control', 'crm_jifen', 'crm_snap', 'crm_sales', 'crm_exhibition', 'crm_receiver', 'crm_common', 'crm_resource', 'crm_other_report', 'crm_market_info', 'crm_finance_info', 'crm_customer_follow', 'crm_was_report', 'crm_answer', 'crm_was', 'crm_was_config', 'crm_salary', 'crm_flow_remote', 'crm_visit_sign_erp', 'crm_take_send_configuration', 'crm_eam', 'crm_pmsys', 'crm_deposit', 'crm_market_report', 'crm_resource_report', 'crm_marketing_ai', 'crm_common_doc'],
  uat: ['crm', 'crm_kts_remote', 'crm_marketing', 'crm_area', 'crm_wechat', 'crm_price_remote', 'crm_intl', 'crm_offer_report', 'crm_price', 'crm_express', 'crm_risk_control', 'crm_jifen', 'crm_snap', 'crm_sales', 'crm_exhibition', 'crm_receiver', 'crm_common', 'crm_resource', 'crm_other_report', 'crm_market_info', 'crm_finance_info', 'crm_customer_follow', 'crm_was_report', 'crm_answer', 'crm_was', 'crm_was_config', 'crm_salary', 'crm_flow_remote', 'crm_visit_sign_erp', 'crm_take_send_configuration', 'crm_eam', 'crm_pmsys', 'crm_deposit', 'crm_market_report', 'crm_resource_report', 'crm_marketing_ai', 'crm_common_doc'],
  prd: ['crm', 'crm_kts_remote', 'crm_marketing', 'crm_area', 'crm_wechat', 'crm_price_remote', 'crm_intl', 'crm_offer_report', 'crm_price', 'crm_express', 'crm_risk_control', 'crm_jifen', 'crm_snap', 'crm_sales', 'crm_exhibition', 'crm_receiver', 'crm_common', 'crm_resource', 'crm_other_report', 'crm_market_info', 'crm_finance_info', 'crm_customer_follow', 'crm_was_report', 'crm_answer', 'crm_was', 'crm_was_config', 'crm_salary', 'crm_flow_remote', 'crm_visit_sign_erp', 'crm_take_send_configuration', 'crm_eam', 'crm_pmsys', 'crm_deposit', 'crm_market_report', 'crm_resource_report', 'crm_marketing_ai', 'crm_common_doc'],
}




// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/crm/index.js